import React from 'react'
import styles from "./bookingPage.module.css"

function Page({ 
  title, 
  subtitle,
  children,
  grid=true,
  centered=false,
  wide=false
}) {
  return (
    <div className={styles.page} style={{ justifyContent: centered ? 'center' : '' }}>
        <div className={`${styles.content} ${wide ? styles.wide : ''}`} >
          <div className={styles.header} style={{ textAlign: centered ? 'center' : 'left' }}>
            <h1 className={styles.title}>{title}</h1>
            {subtitle && <h2 className={styles.subtitle}>{subtitle}</h2>}
          </div>


            {grid ? (
              <div className={styles.grid}>
                {children}
              </div>
            ):(
              <div className={styles.contentContainer} >
                {children}
              </div>
            )}

        </div>
    </div>
  )
}

export default Page
